import React from 'react';
import './SlideCard.css'
import {Container, Col, Row, Image} from 'react-bootstrap'
import {Link} from "react-router-dom";


function SlideCard({title, logo, cover,bgColor,href}) {
    return (

        /*<Container className={'mt-5'}>
            <Row className={'text-center'}>
                <Col>*/
                    <Link to={href} className="outer-card" style={{backgroundColor:bgColor}}>
                        <div className="title-wrapper">
                            <h2>{title}</h2>
                        </div>
                        <div className={"inner-card"}>
                            <h2></h2>
                            <div>
                                <Image src={logo}></Image>
                            </div>
                        </div>
                        <div className={'cover-image'}>
                            <Image src={cover}></Image>
                        </div>
                    </Link>
                /*</Col>
            </Row>
        </Container>*/


    );
}

export default SlideCard;